import * as React from "react";
const SvgFiRrPersonSeatReclined = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M3 2.5C3 1.121 4.12 0 5.5 0S8 1.121 8 2.5 6.879 5 5.5 5A2.5 2.5 0 0 1 3 2.5M22 22h-1.382l-2.671-5.342A2.99 2.99 0 0 0 15.264 15H9.561a1 1 0 0 1-.97-.757L8.03 12h5.969a1 1 0 1 0 0-2h-6.47l-.559-2.242a1.001 1.001 0 0 0-1.941.484l1.62 6.486a3 3 0 0 0 2.912 2.271h5.703c.381 0 .724.212.894.553l2.671 5.342a1.99 1.99 0 0 0 1.789 1.105H22A1 1 0 1 0 22 22m-8-3H9.646a4.99 4.99 0 0 1-4.856-3.812L2.971 7.761a1 1 0 1 0-1.942.477l1.819 7.426A6.984 6.984 0 0 0 9.647 21H14a1 1 0 1 0 0-2z"
    />
  </svg>
);
export default SvgFiRrPersonSeatReclined;
